import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
// middlewares
import { routerMiddleware } from 'connected-react-router';
import promiseMiddleware from 'redux-promise-middleware';
// import promiseErrorMiddleware from './middlewares/globalPromiseError';
import createSagaMiddleware from 'redux-saga';
export const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState, history) {
  const middlewares = [
    promiseMiddleware({
      promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'ERROR']
    }),
    sagaMiddleware,
    routerMiddleware(history)
  ];

  const enhancers = [applyMiddleware(...middlewares)];

  if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension());
    }
  }

  const composedEnhancers = compose(
    applyMiddleware(...middlewares),
    ...enhancers
  );

  const store = createStore(rootReducer, initialState, composedEnhancers);

  sagaMiddleware.run(rootSaga);

  return store;
}



// WEBPACK FOOTER //
// ./src/redux/store.js